enum Paths {
    order = '/orders',
}

export default Paths;



// WEBPACK FOOTER //
// ./src/modules/Order/paths.ts